import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateBatch from '@/modules/batches/api/hooks/useMutationUpdateBatch'
import { GetBatchesDataResponse } from '@/modules/batches/type'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { Badge } from '@/common/ui/badge'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import { useQueryClient } from '@tanstack/react-query'

interface IsActiveBatchesProps {
	row: GetBatchesDataResponse
}

export function IsActiveBatches({ row }: IsActiveBatchesProps) {
	const { mutateAsync: updateBatch } = useMutationUpdateBatch()
	const { data: user } = useQueryProfile()
	const queryClient = useQueryClient()

	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_COUPON,
	)

	const handleMutate = async (value: boolean) => {
		await updateBatch({
			id: row.id,
			request: {
				isActive: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [BatchesQueryKeys.GetBatches],
		})
	}

	if (!hasWritePermission) {
		return (
			<Badge variant={row.isActive ? 'default' : 'secondary'}>
				{row.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
			</Badge>
		)
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
